import { ECalculateStatus } from '../../types/calculate';
import { EFlatStatsStatus } from '../../types/flatStats';
import { IApplicationState } from '../../types/redux';

export function selectCalculatorLoading(state: IApplicationState): boolean {
  return state.calculate.status === ECalculateStatus.Loading;
}

export function selectCalculatorControlsDisabled(state: IApplicationState): boolean {
  return state.flatStats.status === EFlatStatsStatus.Loading;
}

export function selectCalculatorErrorMessage(state: IApplicationState): string {
  return state.calculate.errorMessage || state.flatStats.errorMessage;
}
